module.exports = __webpack_public_path__ + "static/media/week-3a.9943e871.png";